<p-card class="tournament-card" (click)="goTournamentDetail()">
  <div class="flex justify-between">
    <span class="tournament-date">{{ tournament?.startDate | date: 'dd/MM/yyyy' }}</span>
    @if(authService.hasRole(['admin', 'staff'])) {
      <div class="tournament-buttons flex gap-2">
        <!-- edit -->
        @if(tournament?.status === 'PENDING') {
          <p-button icon="pi pi-pencil" rounded size="small" severity="secondary" 
            [pTooltip]="'button.edit' | translate" tooltipPosition="top"
            (click)="editTournament(); $event.stopPropagation();"></p-button>
        }
        <!-- delete -->
        @if(tournament?.status === 'PENDING') {
          <p-button icon="pi pi-trash" rounded size="small" severity="danger"
            [pTooltip]="'button.delete' | translate" tooltipPosition="top"
            (click)="deleteTournament($event); $event.stopPropagation();"></p-button>
        }
        <!-- archive -->
        @if(tournament?.status === 'FINISHED') {
          <p-button icon="pi pi-folder" rounded size="small" severity="danger"
            [pTooltip]="'button.archive' | translate" tooltipPosition="top"
            (click)="archiveTournament($event); $event.stopPropagation();"></p-button>
        }
      </div>
    }
  </div>
  <div class="tournament-title" [pTooltip]="tournament?.name || ('gigantix' | translate)" 
    tooltipEvent="hover" tooltipPosition="top" showDelay="500">
    {{ tournament?.name || ('gigantix' | translate) }}
  </div>
  <hr>
  <div class="tournament-description">{{ tournament?.town }} {{ tournament?.startDate | date: 'yyyy' }}</div>
  <div class="tournament-teams-label">
    <div class="tournament-teams-label-number">{{ tournament?.maxTeams || 0 }}</div>
    <div class="tournament-teams-label-description">{{ 'field.teams' | translate }}</div>
  </div>
</p-card>

<p-confirmpopup />